import { render, staticRenderFns } from "./FiliaisCadastroForm.vue?vue&type=template&id=af044992&scoped=true&"
import script from "./FiliaisCadastroForm.vue?vue&type=script&lang=js&"
export * from "./FiliaisCadastroForm.vue?vue&type=script&lang=js&"
import style0 from "./FiliaisCadastroForm.vue?vue&type=style&index=0&id=af044992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af044992",
  null
  
)

export default component.exports